export const DISHES =
    [
        {
        id: 0,
        name:'Medovik',
        image: '/assets/images/medovik3.png',
        category: 'mains',
        label:'Hot',
        price:'4.99',
        featured: true,
        description:'Medovik is a layer cake popular in countries of the former Soviet Union. The identifying ingredients are honey and smetana or condensed milk. It is a dessert which is known for its lengthy preparation time.'                    
        },
        {
        id: 1,
        name:'Napoleon',
        image: '/assets/images/napoleon.png',
        category: 'appetizer',
        label:'',
        price:'1.99',
        featured: false,
        description:'It is made of two layers of puff pastry, filled with whipped cream, creamy buttercream, vanilla pastry cream (custard cream) or sometimes egg white cream, and is usually sprinkled with powdered sugar. It also can be decorated with cream or covered with a layer of icing.'
        },
        {
        id: 2,
        name:'Ptichye Moloko',
        image: '/assets/images/vadonut2.png',
        category: 'appetizer',
        label:'New',
        price:'1.99',
        featured: false,
        description:'Ptasie mleczko is a soft chocolate-covered candy filled with soft meringue or milk soufflé. It is called ptichye moloko in Russian, Birds Milk in English, 새의 우유 in Korean, and حليب الطيور in Arabic'
        },
        {
        id: 3,
        name:'Fairy Tale',
        image: '/assets/images/elaicheesecake4.png',
        category: 'dessert',
        label:'',
        price:'2.99',
        featured: false,
        description:'A delectable, semi-sweet Uzbek Style Cheese Cake, like British cupcake, typically of a smaller size than the American variety'
        }
    ];